import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CopyUtil } from 'src/app/common/util';
import { FormTaxResponse } from 'src/app/models/tax.model';

@Component({
  selector: 'app-tax-form-two',
  templateUrl: './tax-form-two.component.html',
  styleUrls: ['./tax-form-two.component.scss']
})
export class TaxFormTwoComponent {
  @Input() form: FormTaxResponse = null;

  constructor(
    private toastService: ToastrService
  ) {
  }

  copy(text) {
    CopyUtil.copy(text);
    this.toastService.info("Copiado al portapapeles!");
  }
}
